const initialState = {
    data: [],
    assistants:[],
    linkassistants:[],
    cases:[],
    chartData: {},
    donorChartData: {},
    piechartOptions: {},
    donorChart: {},
    pieChartData: {},
    ManagerchartOptions:[]
  
  
  };
  
  const SuprivisorDashReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'fetch_data_success':
            return {... state, data:action.payload};
            case 'FETCH_CHART_DATA_SUCCESS':
                return { ...state, chartData: action.payload.chartData, chartOptions: action.payload.chartOptions };
                case 'FETCH_PIE_CHART_DATA_SUCCESS':
                  return {...state,pieChartData: action.payload.pieChartData,piechartOptions: action.payload.piechartOptions};
          
          
                case 'FETCH_Donor_CHART_DATA_SUCCESS':
                  return {...state,donorChartData: action.payload.donorChartData,donorChart: action.payload.donorrchartOptions};
           
          


      default:
        return state;
    }
  };
  
  export default SuprivisorDashReducers;
  
  